import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import OffenseDetail from "./OffenseDetail";

class Offenses extends Component {
  componentDidMount() {}

  render() {
    const rowData = [];
    const offenceList = _.get(this.props.offensesNode ? this.props.offensesNode : this.props.node, "offense");
    if (offenceList !== undefined) {
      _.forEach(offenceList, (element, index) => {
        rowData.push(
          <OffenseDetail
            key={`Offense_rec_${index}`}
            record={element}
            {...this.props}
          />
        );
      });
    }
    return (
      <Table columns={1}>
        <Table.Body>
          <Table.Row className={"page-title-black report-sub-section-header"}>
            <Table.Cell>Criminal Records </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{rowData}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default Offenses;



// WEBPACK FOOTER //
// ./src/components/reports/Offenses.js